import React, { useState, useRef, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import styles from './styles.module.css';
import api from '../../service/api';

export default function ChangeDefaultPassword() {

    const [confirmPassword, setConfirmPassword] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const { token } = useParams();
    const toast = useRef(null);
    const history = useHistory();

    const handleWithChangePassword = () => {

        if(confirmPassword.trim() == '' ||  password.trim() == '')
            return toast.current.show({
                severity: 'warn', summary: 'Atenção', 
                detail: 'Preencha os campos: Senha e Confirmação de Senha!', time: 4000});

        if(confirmPassword.trim() !== password.trim())
            return toast.current.show({
                severity: 'warn', summary: 'Atenção', 
                detail: 'As senhas diferem!', time: 4000});
                 

        setLoading(true);
        api().post('/users/validate/recovery/password', { password, confirmPassword, token }).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: 'Senha alterada com sucesso. Você será redirecionado, aguarde...', time: 4000});
              
            } else {
                toast.current.show({
                    severity: 'error', summary: 'Atenção', 
                    time: 6000,
                    detail: (response.data.message || 'Não foi possível alterar a senha!')
                });
            }
            setTimeout(() => {
                return history.push('/');
            }, 5000);
        }).catch(error => {
            setLoading(false);
            return toast.current.show({severity: 'error', summary: 'Atenção', detail: 'Não foi possível alterar a senha!'});
        });
    }

    const header = () => {
        return(
            <div className={styles.contentHeader}>
                <h3>ALTERAR SENHA</h3>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <Toast ref={toast} position="top-right" />
            <Card header={header} className={styles.myCard}>
                <div className={styles.contentForm}>
                    <div>   
                        <label htmlFor="password1" className="block">Informe uma senha</label>
                        <span className={"p-input-icon-left " + styles.w100}>
                            <Password id="password1" 
                                disabled={loading}
                                promptLabel='Sua senha'
                                weakLabel='Fraca'
                                mediumLabel='Média'
                                strongLabel='Forte'
                                autoComplete="off"
                               
                                className={styles.w100}
                                value={password} toggleMask
                                onChange={(e) => setPassword(String(e.target.value || '').replaceAll(' ', ''))} placeholder="Informe sua senha" />
                        </span>
                    </div>

                    <div>   
                        <label htmlFor="password2" className="block">Confirme sua senha</label>
                        <Password id="password2" 
                            disabled={loading}
                            className={styles.w100}
                            feedback={false}
                            value={confirmPassword} toggleMask
                            autoComplete="off"
                            onChange={(e) => setConfirmPassword(String(e.target.value || '').replaceAll(' ', ''))} placeholder="Confirme sua senha" />
                    </div>
                    <div className={styles.buttonForm}>
                        <Button loading={loading} label={loading ? 'Aguarde...' : 'Alterar'} className="p-button-rounded" onClick={handleWithChangePassword} />
                    </div>

                </div>
            </Card>
        </div>
    );
}